'use strict';

var Type = require('../type');

module.exports = new Type('tag:yaml.org,2002:str', {
  kind: 'scalar',
  construct: function (data) { return data !== null ? data : ''; }
});



//////////////////
// WEBPACK FOOTER
// ./~/js-yaml/lib/js-yaml/type/str.js
// module id = 833
// module chunks = 0